export default "__VITE_PUBLIC_ASSET__a4a9ca4a__"